import { ModalMsgService } from './../../../../services/modal-msg.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable, pipe } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { CiacService } from 'src/app/services/http/ciac.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-form-consultas-fornecedores',
  templateUrl: './form-consultas-fornecedores.component.html',
  styleUrls: ['./form-consultas-fornecedores.component.scss']
})
export class FormConsultasFornecedoresComponent implements OnInit {

  sorting: { 
    id: "asc",
    nome: ""
  }
  filter = {
    sorting: { 
      id: "asc",
      nome: ""
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };

  // Dados
  filterDados = {
    sorting: { 
      id: "asc",
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 1000,
  };

  formDados = new FormGroup({
    consulta: new FormControl('', [Validators.required]),
    fornecedor: new FormControl('', [Validators.required]),
    tipoRequisicao: new FormControl('', [Validators.required]),
    url: new FormControl('', [Validators.required])
  });

  listaTipoRequisicao;
  idConsulta: any;
  listaConsultas = [];
  consultaSelecionada;
  idFornecedor: any;
  listaFornecedor = [];
  fornecedorSelecionado;
  valueConsulta = null;
  valueFornecedor = null;

  inputConsultaFormat = (u) => u.nome;
  pesquisaConsulta= (text: Observable<string>) =>
  text.pipe(debounceTime(200), distinctUntilChanged(), map(term => this.listaConsultas['lista'].filter(c => c.nome.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)));
  inputFornecedorFormat = (u) => u.nome;
  pesquisaFornecedor= (text: Observable<string>) =>
  text.pipe(debounceTime(200), distinctUntilChanged(), map(term => this.listaFornecedor['lista'].filter(c => c.nome.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)));
  // Fim dados

  // Parametros consultas
  sortingParamConsultas: { 
    id: "asc",
    nome: ""
  }
  filterParamsConsultas = {
    sorting: { 
      id: "asc",
      nome: ""
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 5,
  };
  formParametrosConsulta = new FormGroup({
    chave: new FormControl(''),
    valor: new FormControl(''),
    tipoEnvio: new FormControl(''),
  });
  listaParamsConsulta = [];
  listaEnvioParamsConsulta;
  idParamsConsulta = 1;
  totalParamsConsultas:number = 1;
  // Fim parametros consultas

  // Parametros consultas extras
  sortingParametrosExtra: { 
    id: "asc",
    nome: ""
  }
  filterParametroExtra = {
    sorting: { 
      id: "asc",
      nome: ""
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 1000,
  };
  formParametrosConsultaExtra = new FormGroup({
    chave: new FormControl(''),
    pesquisa: new FormControl(''),
    tipoEnvio: new FormControl(''),
  });
  listaParamsConsultaExtra = [];
  listaEnvioParamsConsultaExtra;
  listaCampoPesquisa;
  idParamsConsultaExtra = 1;
  // Fim parametros consultas extras
  
  total:number = 1;
  tableLoading = true;
  id;

  constructor(private ciacService: CiacService, private router: Router, private modal: ModalMsgService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.inicialize();
    this.id = this.activatedRoute.snapshot.params.id || null;

    if(this.id) {
      this.ciacService.getConsultaFornecedor(this.id).then(c => {

        this.formDados.controls.consulta.clearValidators();
        this.formDados.controls.consulta.updateValueAndValidity();

        this.formDados.controls.fornecedor.clearValidators();
        this.formDados.controls.fornecedor.updateValueAndValidity();

        // Form 1
        this.idConsulta = c['idConsulta'];
        this.idFornecedor = c['idFornecedor'];

        this.valueConsulta = c['consulta'];
        this.valueFornecedor = c['fornecedor'];
        this.formDados.controls.url.patchValue(c['requisicao']['url']);
        this.formDados.controls.tipoRequisicao.patchValue(c['requisicao']['idTipoRequisicao']);
  
        // Form 2
        c['parametros'].forEach(e => {
          this.listaParamsConsulta.push({
            'id': e.id,
            'idTipoEnvio': e.idTipoEnvio,
            'chave': e.chave,
            'valor': e.valor,
            'envio': e.tipoEnvio
          });
        });
  
        // Form 3
        c['parametrosExtras'].forEach(e => {
          this.listaParamsConsultaExtra.push({
            'id': e.id,
            'idTipoEnvio': e.idTipoEnvio,
            'idCampoPesquisa': e.idCampoPesquisa,
            'pesquisa': e.campoPesquisa,
            'chave': e.chave,
            'envio': e.tipoEnvio
          });
        });
      }); 
    }
  }

  inicialize() {
    // Dados
    this.ciacService.getListaTipoRequisicao().then(c => { this.listaTipoRequisicao = c });
    this.ciacService.getListaConsultasCredito(this.filterDados).then(u => this.listaConsultas = u);
    this.ciacService.getListaFornecedores(this.filterDados).then(u => this.listaFornecedor = u);
    // Fim Dados

    // Parametros consulta
    this.ciacService.getListaTipoParametros().then(c => { this.listaEnvioParamsConsulta = c});
    // Fim parametros consulta

    // Parametros consulta extra
    this.ciacService.getListaTipoParametros().then(c => { this.listaEnvioParamsConsultaExtra = c });
    // Fim parametros consulta

    // Parametros de pesquisa
    this.ciacService.getCampoPesquisa().then( c => { this.listaCampoPesquisa = c });
    // Fim parametros pesquisa
  }

  addFiltroConsulta($event) {
    this.formDados.controls.consulta.patchValue(parseInt($event.item.id));
  }

  removeFiltroConsulta() {
    this.formDados.controls.consulta.reset();
  }

  addFiltroFornecedor($event) {
    this.formDados.controls.fornecedor.patchValue(parseInt($event.item.id));
  }

  removeFiltroFornecedor() {
    this.formDados.controls.fornecedor.reset();
  }

  // setPageSize(pageSize) {
  //   this.filter.page = 1;
  //   this.filter.per_page = pageSize;
  //   // this.getListaConsultas();
  // }

  // nextPage() {
  //   // this.getListaConsultas();
  // }

  // Parametros Consulta
  addParamConsulta() {
    let filterTipoParam = [];
    this.listaEnvioParamsConsulta.forEach(e => {
      if(e.id == this.formParametrosConsulta.controls.tipoEnvio.value) {
        filterTipoParam.push(e);
      }
    });
    let dados = {
      id: this.idParamsConsulta++,
      idTipoEnvio: parseInt(filterTipoParam[0].id),
      chave: this.formParametrosConsulta.controls.chave.value,
      valor: this.formParametrosConsulta.controls.valor.value,
      envio: filterTipoParam[0].tipoEnvioParametro
    }

    if(dados.chave != '' && dados.valor != '' && dados.chave != null && dados.valor != null) {
      this.listaParamsConsulta.push(dados);
      this.formParametrosConsulta.controls.chave.reset();
      this.formParametrosConsulta.controls.valor.reset();
      this.formParametrosConsulta.controls.tipoEnvio.patchValue('');
      this.formParametrosConsulta.controls.tipoEnvio.markAsUntouched();
    }else {
      this.formParametrosConsulta.markAllAsTouched();
      return; 
    }
  }

  editParamConsulta(id) {
    this.listaParamsConsulta.filter(c => {
      if(c.id === id) {
        this.formParametrosConsulta.controls.chave.patchValue(c.chave);
        this.formParametrosConsulta.controls.valor.patchValue(c.valor);
        this.formParametrosConsulta.controls.tipoEnvio.patchValue(c.idTipoEnvio);
        let index = this.listaParamsConsulta.indexOf(c);
        if ( index > -1) {
          this.listaParamsConsulta.splice(index, 1);
        }
      }
    });
  }

  delParamConsulta(id) {
    this.listaParamsConsulta.filter(c => {
      if(c.id === id) {
        let index = this.listaParamsConsulta.indexOf(c);
        if ( index > -1) {
          this.listaParamsConsulta.splice(index, 1);
        }
      }
    });
  }
  // Fim Parametros consulta
  
  addParamConsultaExtra() {
    let filterTipoParam = [];
    let filterPesquisa = [];

    this.listaEnvioParamsConsultaExtra.forEach(e => {
      if(e.id == this.formParametrosConsultaExtra.controls.tipoEnvio.value) {
        filterTipoParam.push(e);
      }
    });

    this.listaCampoPesquisa.forEach(p => {
      if(p.id == this.formParametrosConsultaExtra.controls.pesquisa.value) {
        filterPesquisa.push(p)
      }  
    });

    let dados = {
      id: this.idParamsConsultaExtra++,
      idTipoEnvio: parseInt(filterTipoParam[0].id),
      idCampoPesquisa: parseInt(filterPesquisa[0].id),
      chave: this.formParametrosConsultaExtra.controls.chave.value,
      pesquisa: filterPesquisa[0].campoPesquisa,
      envio: filterTipoParam[0].tipoEnvioParametro
    }

    if(dados.chave != '' && dados.chave != null && dados.pesquisa != null) {
      this.listaParamsConsultaExtra.push(dados);
      this.formParametrosConsultaExtra.controls.chave.reset();
      this.formParametrosConsultaExtra.controls.pesquisa.reset();
      this.formParametrosConsultaExtra.controls.pesquisa.patchValue('');
      this.formParametrosConsultaExtra.controls.pesquisa.markAsUntouched();
      this.formParametrosConsultaExtra.controls.tipoEnvio.patchValue('');
      this.formParametrosConsultaExtra.controls.tipoEnvio.markAsUntouched();
    }else {
      this.formParametrosConsultaExtra.markAllAsTouched();
      return;
    }
  }

  editParamConsultaExtra(id) {
    this.listaParamsConsultaExtra.filter(c => {
      if(c.id === id) {
        this.formParametrosConsultaExtra.controls.chave.patchValue(c.chave);
        this.formParametrosConsultaExtra.controls.pesquisa.patchValue(c.idCampoPesquisa);
        this.formParametrosConsultaExtra.controls.tipoEnvio.patchValue(c.idTipoEnvio);
        let index = this.listaParamsConsultaExtra.indexOf(c);
        if ( index > -1) {
          this.listaParamsConsultaExtra.splice(index, 1);
        }
      }
    });
  }

  delParamConsultaExtra(id) {
    this.listaParamsConsultaExtra.filter(c => {
      if(c.id === id) {
        let index = this.listaParamsConsultaExtra.indexOf(c);
        if ( index > -1) {
          this.listaParamsConsultaExtra.splice(index, 1);
        }
      }
    });
  }

  criarJSON() {
    let parametros = [];
    let parametrosExtras = [];

    if(this.id) {
      this.listaParamsConsulta.forEach(c => {
        let array = {
          idTipoEnvio: c.idTipoEnvio,
          chave: c.chave,
          valor: c.valor,
        }
        parametros.push(array);
      });

      this.listaParamsConsultaExtra.forEach(c => {
        let array = {
          idTipoEnvio: c.idTipoEnvio,
          chave: c.chave,
          idCampoPesquisa: c.idCampoPesquisa,
        }
        parametrosExtras.push(array);
      });
      let dadosCadastro = {
        id: parseInt(this.id),
        idConsulta: this.formDados.controls.consulta.value && this.formDados.controls.consulta.value != undefined ? parseInt(this.formDados.controls.consulta.value.id) : this.idConsulta,
        idFornecedor: this.formDados.controls.fornecedor.value && this.formDados.controls.fornecedor.value != undefined ? parseInt(this.formDados.controls.fornecedor.value.id) : this.idFornecedor,
        requisicao: {
          idTipoRequisicao: this.formDados.controls.tipoRequisicao.value || this.formDados.controls.tipoRequisicao.value != NaN ? parseInt(this.formDados.controls.tipoRequisicao.value) : null,
          url: this.formDados.controls.url.value
        },
        parametros: parametros,
        parametrosExtras: parametrosExtras
      }
      return dadosCadastro;
    }else {
      this.listaParamsConsulta.forEach(c => {
        let array = {
          idTipoEnvio: c.idTipoEnvio,
          chave: c.chave,
          valor: c.valor,
        }
        parametros.push(array);
      });
  
      this.listaParamsConsultaExtra.forEach(c => {
        let array = {
          idTipoEnvio: c.idTipoEnvio,
          chave: c.chave,
          idCampoPesquisa: c.idCampoPesquisa,
        }
        parametrosExtras.push(array);
      });
  
      let dadosCadastro = {
        idConsulta: this.formDados.controls.consulta.value && this.formDados.controls.consulta.value != undefined ? this.formDados.controls.consulta.value.id : null,
        idFornecedor: this.formDados.controls.fornecedor.value && this.formDados.controls.fornecedor.value != undefined ? this.formDados.controls.fornecedor.value.id : null,
        requisicao: {
          idTipoRequisicao: this.formDados.controls.tipoRequisicao.value && this.formDados.controls.tipoRequisicao.value != NaN ? parseInt(this.formDados.controls.tipoRequisicao.value) : null,
          url: this.formDados.controls.url.value
        },
        parametros: parametros,
        parametrosExtras: parametrosExtras
      };
      return dadosCadastro;
    }
  }

  submitForm() {
    if(this.id && this.id != null && this.id != '') {
      let dados = this.criarJSON();
      if(this.formDados.controls.consulta.value === '' || this.formDados.controls.fornecedor.value === '' ) {
        this.formDados.markAllAsTouched();
        // this.formParametrosConsulta.markAllAsTouched();

        if(this.formDados.controls.consulta.value === '') {
          this.formDados.controls.consulta.setValidators([Validators.required]);
          this.formDados.controls.consulta.updateValueAndValidity();
        }

        if(this.formDados.controls.fornecedor.value === '') {
          this.formDados.controls.fornecedor.setValidators([Validators.required]);
          this.formDados.controls.fornecedor.updateValueAndValidity();
        }
        return;
      }else {
        this.ciacService.editConsultaFornecedor(dados).then(c => {
          if(c.success) {
            this.router.navigate(['ciac', 'consultas-fornecedores', 'listar']);
          }else {
            this.modal.openDialog(
              'Erro ao editar informações',
              'Por favor, tente novamente.',
              'danger'
            );
            return;
          }
        });
      }
    }else {
      let dados = this.criarJSON();
      if(this.formDados.invalid) {
        this.formDados.markAllAsTouched();
        return;
      }else {
        this.ciacService.addConsultaFornecedor(dados).then(c => {
          if(c.success) {
            this.router.navigate(['ciac', 'consultas-fornecedores', 'listar']);
          }else {
            this.modal.openDialog(
              'Erro ao cadastrar informações',
              'Por favor, tente novamente.',
              'danger'
            );
            return;
          }
        });
      }
    }
  }
}
